// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-list-updating[data-v-907b0c36] {
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 9999;
  width: 100%;
  background: var(--bg-color2);
  opacity: 75%;
}
.visible-chat[data-v-907b0c36] {
  opacity: 1 !important;
}
.extender[data-v-907b0c36] {
  display: flex;
  flex-grow: 1;
}
.message-list-wrapper[data-v-907b0c36] {
  flex-grow: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--bg-color2);
}
.message-list-wrapper .message-list[data-v-907b0c36] {
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  opacity: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow-anchor: none;
}
.message-list-wrapper .message-list.focused[data-v-907b0c36] {
  overflow-anchor: auto;
}
.message-list-wrapper .message-list.focused .list[data-v-907b0c36] {
  overflow-anchor: auto;
}
.message-list-wrapper .message-list.focused .list[data-v-907b0c36]:after {
  overflow-anchor: auto;
}
.message-list-wrapper .message-list .list[data-v-907b0c36] {
  width: initial;
  text-align: left;
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  outline: none;
  margin-bottom: 30px;
}
.message-list-wrapper .message-list .list *[data-v-907b0c36] {
  overflow-anchor: none;
}
.message-list-wrapper .message-list .list[data-v-907b0c36]:after {
  content: ' ';
  display: block;
  height: 1px;
  overflow-anchor: none;
}
.message-send-block[data-v-907b0c36] {
  position: relative;
}
.message-send-block .message-send-cont[data-v-907b0c36],
.message-send-block .add-bot-wrapper[data-v-907b0c36] {
  display: flex;
  position: relative;
  padding: 5px 0px;
  border-top: solid 1px var(--border-top-input);
  background: var(--bg-color);
}
.message-send-block .message-send-cont .add-bot-wrapper[data-v-907b0c36],
.message-send-block .add-bot-wrapper .add-bot-wrapper[data-v-907b0c36] {
  height: 51px;
}
.message-send-block .message-send-cont .clip[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip[data-v-907b0c36] {
  margin: auto 10px;
  background-color: inherit;
  color: var(--toolbtn-color);
}
.message-send-block .message-send-cont .clip-cont[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip-cont[data-v-907b0c36] {
  position: absolute;
  display: flex;
  bottom: 50px;
  flex-direction: column;
  font-size: 22px;
  color: white;
}
.message-send-block .message-send-cont .clip-cont .clip-cont-elem[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem[data-v-907b0c36] {
  display: flex;
  align-items: center;
  backdrop-filter: blur(1px);
  width: fit-content;
  height: fit-content;
}
.message-send-block .message-send-cont .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36] {
  margin: 8px 6px;
  border-radius: 50%;
  width: 50px;
  line-height: 50px;
  background-color: var(--icon-bgcolor2);
  text-align: center;
  box-shadow: 0px 2px 10px 0px var(--clip-elem-shadow-color);
  transition: 0.1s all;
}
.message-send-block .message-send-cont .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36]:not(.disabled-cont-btn):hover,
.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36]:not(.disabled-cont-btn):hover {
  cursor: pointer;
  background-color: #59C5F9;
}
.message-send-block .message-send-cont .clip-cont .clip-cont-elem span[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem span[data-v-907b0c36] {
  color: var(--clip-cont-color);
  background-color: var(--clip-elem-bgcolor);
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 14px;
  backdrop-filter: blur(11px);
  box-shadow: 0px 2px 7px 0px var(--clip-elem-shadow-color);
}
.message-send-block .message-send-cont .clip-cont .clip-cont-elem span[data-v-907b0c36]:not(.disabled-cont-btn),
.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem span[data-v-907b0c36]:not(.disabled-cont-btn) {
  cursor: pointer;
}
.message-send-block .message-send-cont .clip-btn[data-v-907b0c36],
.message-send-block .add-bot-wrapper .clip-btn[data-v-907b0c36] {
  flex-basis: 40px;
  flex-shrink: 0;
  font-size: 17px;
}
.message-send-block .message-send-cont .buttons-wrapper[data-v-907b0c36],
.message-send-block .add-bot-wrapper .buttons-wrapper[data-v-907b0c36] {
  display: flex;
  font-size: 1.25em;
}
.message-send-block .message-send-cont .buttons[data-v-907b0c36],
.message-send-block .add-bot-wrapper .buttons[data-v-907b0c36] {
  margin: 0 10px;
  color: var(--toolbtn-color);
}
.message-send-block .message-send-cont .buttons.right-btn[data-v-907b0c36],
.message-send-block .add-bot-wrapper .buttons.right-btn[data-v-907b0c36] {
  margin: 0 0 auto 0;
  align-items: center;
}
.message-send-block .message-send-cont .buttons[data-v-907b0c36]:hover,
.message-send-block .add-bot-wrapper .buttons[data-v-907b0c36]:hover {
  cursor: pointer;
  color: var(--toolbtn-color-hover);
}
.message-send-block .message-send-cont .buttons i.fas.fa-grip-horizontal[data-v-907b0c36],
.message-send-block .add-bot-wrapper .buttons i.fas.fa-grip-horizontal[data-v-907b0c36] {
  font-size: 23px;
}
.message-send-block .message-send-cont .send-message[data-v-907b0c36],
.message-send-block .add-bot-wrapper .send-message[data-v-907b0c36],
.message-send-block .message-send-cont .edit-message[data-v-907b0c36],
.message-send-block .add-bot-wrapper .edit-message[data-v-907b0c36] {
  margin: auto 10px auto 0;
}
.message-send-block .message-send-cont .send-message i[data-v-907b0c36],
.message-send-block .add-bot-wrapper .send-message i[data-v-907b0c36],
.message-send-block .message-send-cont .edit-message i[data-v-907b0c36],
.message-send-block .add-bot-wrapper .edit-message i[data-v-907b0c36] {
  color: var(--toolbtn-active-color);
}
.message-send-block .message-send-cont .edit-message i[data-v-907b0c36],
.message-send-block .add-bot-wrapper .edit-message i[data-v-907b0c36] {
  font-size: 18px;
}
.message-send-block .message-send-cont .audio-activate-button[data-v-907b0c36],
.message-send-block .add-bot-wrapper .audio-activate-button[data-v-907b0c36] {
  margin: auto 10px auto 0;
}
.message-send-block .message-send-cont .audio-activate-button i[data-v-907b0c36],
.message-send-block .add-bot-wrapper .audio-activate-button i[data-v-907b0c36] {
  font-size: 17px;
}
.message-send-block .message-send-cont .disable-btn[data-v-907b0c36],
.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36] {
  padding-top: 1px;
  cursor: initial;
}
.message-send-block .message-send-cont .disable-btn i[data-v-907b0c36],
.message-send-block .add-bot-wrapper .disable-btn i[data-v-907b0c36] {
  color: var(--elem-grey-color);
}
.message-send-block .message-send-cont .disable-btn[data-v-907b0c36]:hover,
.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36]:hover {
  cursor: initial;
}
.message-send-block .message-send-cont .disable-btn[data-v-907b0c36]:active::after,
.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36]:active::after {
  content: none;
}
.message-send-block .message-send-cont .disabled-cont-btn[data-v-907b0c36],
.message-send-block .add-bot-wrapper .disabled-cont-btn[data-v-907b0c36] {
  filter: opacity(0.5) grayscale(1);
}
.message-send-block .message-send-cont .fade-enter-active[data-v-907b0c36],
.message-send-block .add-bot-wrapper .fade-enter-active[data-v-907b0c36],
.message-send-block .message-send-cont .fade-leave-active[data-v-907b0c36],
.message-send-block .add-bot-wrapper .fade-leave-active[data-v-907b0c36] {
  transition: opacity .1s;
}
.message-send-block .message-send-cont .fade-enter[data-v-907b0c36],
.message-send-block .add-bot-wrapper .fade-enter[data-v-907b0c36],
.message-send-block .message-send-cont .fade-leave-to[data-v-907b0c36],
.message-send-block .add-bot-wrapper .fade-leave-to[data-v-907b0c36] {
  opacity: 0;
}
.message-send-block .message-send-cont.add-bot-wrapper[data-v-907b0c36],
.message-send-block .add-bot-wrapper.add-bot-wrapper[data-v-907b0c36] {
  cursor: pointer;
}
.message-send-block .message-send-cont.add-bot-wrapper[data-v-907b0c36]:hover,
.message-send-block .add-bot-wrapper.add-bot-wrapper[data-v-907b0c36]:hover {
  background-color: var(--list-item-bghover);
}
.message-send-block .message-send-cont.add-bot-wrapper .connect[data-v-907b0c36],
.message-send-block .add-bot-wrapper.add-bot-wrapper .connect[data-v-907b0c36] {
  margin: auto;
  font-size: 16px;
  color: var(--toolbtn-active-color);
  font-weight: bold;
  text-transform: uppercase;
}
.bot-keyboard-btn[data-v-907b0c36] {
  border: 1px solid;
  border-radius: 4px;
  height: 20px;
  width: 20px;
  padding: 2px;
}
.bot-keyboard-btn .bot-keyboard-btn-line[data-v-907b0c36] {
  display: flex;
}
.bot-keyboard-btn .bot-keyboard-btn-line .bot-keyboard-btn-square[data-v-907b0c36] {
  border-radius: 1px;
  height: 5px;
  width: 5px;
  background-color: var(--toolbtn-color);
  margin: 1px;
}
.bot-comands-btn[data-v-907b0c36] {
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  border: 1px solid var(--toolbtn-color);
  border-radius: 4px;
  cursor: pointer;
}
.bot-comands-btn[data-v-907b0c36]:hover {
  border-color: inherit;
}
.selected-bot-btn[data-v-907b0c36] {
  border-color: var(--toolbtn-active-color);
}
.selected-bot-btn .bot-keyboard-btn-square[data-v-907b0c36] {
  background-color: #00AAFB !important;
}
.message-send-block-locked[data-v-907b0c36] {
  display: flex;
  align-items: center;
}
.message-send-block-locked i[data-v-907b0c36] {
  color: var(--toolbtn-color-hover);
  margin-left: 24px;
  margin-right: 32px;
}
.message-send-block-locked span[data-v-907b0c36] {
  color: #cccccc;
  font-size: 16px;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.warning-message[data-v-907b0c36] {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 18px;
  font-size: small;
  background-color: var(--list-item-bghover);
  border-top: 1px solid var(--border-bottom-section);
}
@keyframes link-to-new-msgs-in-907b0c36 {
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}
.link-to-new-msgs-fade-enter-active[data-v-907b0c36],
.link-to-new-msgs-fade-leave-active[data-v-907b0c36] {
  animation: link-to-new-msgs-in-907b0c36 0.1s ease-in;
}
.link-to-new-msgs-fade-enter[data-v-907b0c36],
.link-to-new-msgs-fade-leave-to[data-v-907b0c36] {
  animation: link-to-new-msgs-in-907b0c36 0.5s ease-in reverse;
}
.link-to-new-msgs[data-v-907b0c36] {
  text-align: center;
  position: absolute;
  bottom: 29px;
  right: 29px;
  width: 50px;
  height: 50px;
  background-color: var(--link-new-msgs-bgcolor);
  box-shadow: -1px 1px 4px 0px var(--link-new-message-shadow);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 25px;
  color: var(--custom-textarea-color);
  transition-property: opacity;
  transition-duration: .5s;
  opacity: 1;
  visibility: visible;
  z-index: 0;
}
.link-to-new-msgs.novisible[data-v-907b0c36] {
  transition-property: opacity;
  transition-duration: .5s;
  visibility: hidden;
  opacity: 0;
}
.link-to-new-msgs .unwatched-count[data-v-907b0c36] {
  position: absolute;
  background-color: var(--elem-red-color);
  color: #faebef;
  border-radius: 13px;
  right: -3px;
  top: -3px;
  font-size: 12px;
  padding: 1px 5.5px 0px 5.5px;
}
.link-to-new-msgs i[data-v-907b0c36] {
  margin: auto;
}
.message-input[data-v-907b0c36] {
  outline: none;
  resize: none;
  width: 100%;
  background-color: inherit;
  max-height: 190px;
  padding-left: 10px;
  padding-right: 10px;
  border: none;
  align-self: flex-end;
  margin: auto;
  /*&::-webkit-input-placeholder { font-size: 1.2em;}
      &::-moz-placeholder { color:#f00; font-family: Georgia;}
      &:-ms-input-placeholder { color:#f00; font-family: Georgia;}
      &:-moz-placeholder { color:#f00; font-family: Georgia;}*/
}
.message-overflow .message-overflow-alert[data-v-907b0c36] {
  display: flex;
  flex-direction: row;
  width: auto;
  margin: auto 10px 10px 10px;
  padding: 10px;
  height: 40px;
  line-height: 20px;
  border-radius: 5px;
  border: solid 1px #b84b4b;
  color: #b81c1c;
  background-color: rgba(211, 88, 26, 0.3);
}
.message-overflow .message-overflow-alert span[data-v-907b0c36] {
  align-self: flex-start;
}
.message-overflow .message-overflow-alert div[data-v-907b0c36] {
  align-self: flex-end;
  margin: auto 0px auto auto;
  cursor: pointer;
}
.message-overflow .fade-enter-active[data-v-907b0c36],
.message-overflow .fade-leave-active[data-v-907b0c36] {
  transition: opacity .5s;
}
.message-overflow .fade-enter[data-v-907b0c36],
.message-overflow .fade-leave-to[data-v-907b0c36] {
  opacity: 0;
}
.notice-new-msg-wrapper[data-v-907b0c36] {
  width: calc(100% + 50px);
  margin: 0 auto 0 -25px;
  padding: 13px 0;
  display: flex;
}
.notice-new-msg-wrapper .notice-new-msg[data-v-907b0c36] {
  width: 100%;
  background-color: var(--message-system-bgcolor);
  border-radius: 3px;
  text-align: center;
  padding: 3px 5px;
  color: var(--elem-grey-color);
  margin: auto;
  font-size: 12px;
  justify-content: center;
}
.with-scroll li.notice-new-msg-wrapper[data-v-907b0c36] {
  margin-left: -10px;
  width: calc(100% + 35px);
}
@keyframes notice-new-msg-in-907b0c36 {
0% {
    transform: scale(0);
}
100% {
    transform: scale(1);
}
}
@keyframes notice-new-msg-out-907b0c36 {
0% {
    transform: scale(1);
}
100% {
    transform: scale(0);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatBase.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,0DAA0D;EAC1D,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;EAC7B,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,yDAAyD;AAC3D;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,iCAAiC;AACnC;AACA;;EAEE,eAAe;AACjB;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;;;;EAIE,kCAAkC;AACpC;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,iCAAiC;AACnC;AACA;;;;EAIE,uBAAuB;AACzB;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,kDAAkD;AACpD;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;AACA;;EAEE,oDAAoD;AACtD;AACA;;EAEE,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,2DAA2D;EAC3D,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mCAAmC;EACnC,4BAA4B;EAC5B,wBAAwB;EACxB,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ;;;8DAG4D;AAC9D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;AACA;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA","sourcesContent":[".message-list-updating[data-v-907b0c36] {\n  display: flex;\n  position: absolute;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  z-index: 9999;\n  width: 100%;\n  background: var(--bg-color2);\n  opacity: 75%;\n}\n.visible-chat[data-v-907b0c36] {\n  opacity: 1 !important;\n}\n.extender[data-v-907b0c36] {\n  display: flex;\n  flex-grow: 1;\n}\n.message-list-wrapper[data-v-907b0c36] {\n  flex-grow: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: var(--bg-color2);\n}\n.message-list-wrapper .message-list[data-v-907b0c36] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n  opacity: 0;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow-anchor: none;\n}\n.message-list-wrapper .message-list.focused[data-v-907b0c36] {\n  overflow-anchor: auto;\n}\n.message-list-wrapper .message-list.focused .list[data-v-907b0c36] {\n  overflow-anchor: auto;\n}\n.message-list-wrapper .message-list.focused .list[data-v-907b0c36]:after {\n  overflow-anchor: auto;\n}\n.message-list-wrapper .message-list .list[data-v-907b0c36] {\n  width: initial;\n  text-align: left;\n  margin: 0 12px;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  margin-bottom: 30px;\n}\n.message-list-wrapper .message-list .list *[data-v-907b0c36] {\n  overflow-anchor: none;\n}\n.message-list-wrapper .message-list .list[data-v-907b0c36]:after {\n  content: ' ';\n  display: block;\n  height: 1px;\n  overflow-anchor: none;\n}\n.message-send-block[data-v-907b0c36] {\n  position: relative;\n}\n.message-send-block .message-send-cont[data-v-907b0c36],\n.message-send-block .add-bot-wrapper[data-v-907b0c36] {\n  display: flex;\n  position: relative;\n  padding: 5px 0px;\n  border-top: solid 1px var(--border-top-input);\n  background: var(--bg-color);\n}\n.message-send-block .message-send-cont .add-bot-wrapper[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .add-bot-wrapper[data-v-907b0c36] {\n  height: 51px;\n}\n.message-send-block .message-send-cont .clip[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip[data-v-907b0c36] {\n  margin: auto 10px;\n  background-color: inherit;\n  color: var(--toolbtn-color);\n}\n.message-send-block .message-send-cont .clip-cont[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip-cont[data-v-907b0c36] {\n  position: absolute;\n  display: flex;\n  bottom: 50px;\n  flex-direction: column;\n  font-size: 22px;\n  color: white;\n}\n.message-send-block .message-send-cont .clip-cont .clip-cont-elem[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem[data-v-907b0c36] {\n  display: flex;\n  align-items: center;\n  backdrop-filter: blur(1px);\n  width: fit-content;\n  height: fit-content;\n}\n.message-send-block .message-send-cont .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36] {\n  margin: 8px 6px;\n  border-radius: 50%;\n  width: 50px;\n  line-height: 50px;\n  background-color: var(--icon-bgcolor2);\n  text-align: center;\n  box-shadow: 0px 2px 10px 0px var(--clip-elem-shadow-color);\n  transition: 0.1s all;\n}\n.message-send-block .message-send-cont .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36]:not(.disabled-cont-btn):hover,\n.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem .clip-cont-btn[data-v-907b0c36]:not(.disabled-cont-btn):hover {\n  cursor: pointer;\n  background-color: #59C5F9;\n}\n.message-send-block .message-send-cont .clip-cont .clip-cont-elem span[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem span[data-v-907b0c36] {\n  color: var(--clip-cont-color);\n  background-color: var(--clip-elem-bgcolor);\n  font-size: 14px;\n  padding: 6px 10px;\n  border-radius: 14px;\n  backdrop-filter: blur(11px);\n  box-shadow: 0px 2px 7px 0px var(--clip-elem-shadow-color);\n}\n.message-send-block .message-send-cont .clip-cont .clip-cont-elem span[data-v-907b0c36]:not(.disabled-cont-btn),\n.message-send-block .add-bot-wrapper .clip-cont .clip-cont-elem span[data-v-907b0c36]:not(.disabled-cont-btn) {\n  cursor: pointer;\n}\n.message-send-block .message-send-cont .clip-btn[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .clip-btn[data-v-907b0c36] {\n  flex-basis: 40px;\n  flex-shrink: 0;\n  font-size: 17px;\n}\n.message-send-block .message-send-cont .buttons-wrapper[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .buttons-wrapper[data-v-907b0c36] {\n  display: flex;\n  font-size: 1.25em;\n}\n.message-send-block .message-send-cont .buttons[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .buttons[data-v-907b0c36] {\n  margin: 0 10px;\n  color: var(--toolbtn-color);\n}\n.message-send-block .message-send-cont .buttons.right-btn[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .buttons.right-btn[data-v-907b0c36] {\n  margin: 0 0 auto 0;\n  align-items: center;\n}\n.message-send-block .message-send-cont .buttons[data-v-907b0c36]:hover,\n.message-send-block .add-bot-wrapper .buttons[data-v-907b0c36]:hover {\n  cursor: pointer;\n  color: var(--toolbtn-color-hover);\n}\n.message-send-block .message-send-cont .buttons i.fas.fa-grip-horizontal[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .buttons i.fas.fa-grip-horizontal[data-v-907b0c36] {\n  font-size: 23px;\n}\n.message-send-block .message-send-cont .send-message[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .send-message[data-v-907b0c36],\n.message-send-block .message-send-cont .edit-message[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .edit-message[data-v-907b0c36] {\n  margin: auto 10px auto 0;\n}\n.message-send-block .message-send-cont .send-message i[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .send-message i[data-v-907b0c36],\n.message-send-block .message-send-cont .edit-message i[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .edit-message i[data-v-907b0c36] {\n  color: var(--toolbtn-active-color);\n}\n.message-send-block .message-send-cont .edit-message i[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .edit-message i[data-v-907b0c36] {\n  font-size: 18px;\n}\n.message-send-block .message-send-cont .audio-activate-button[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .audio-activate-button[data-v-907b0c36] {\n  margin: auto 10px auto 0;\n}\n.message-send-block .message-send-cont .audio-activate-button i[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .audio-activate-button i[data-v-907b0c36] {\n  font-size: 17px;\n}\n.message-send-block .message-send-cont .disable-btn[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36] {\n  padding-top: 1px;\n  cursor: initial;\n}\n.message-send-block .message-send-cont .disable-btn i[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .disable-btn i[data-v-907b0c36] {\n  color: var(--elem-grey-color);\n}\n.message-send-block .message-send-cont .disable-btn[data-v-907b0c36]:hover,\n.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36]:hover {\n  cursor: initial;\n}\n.message-send-block .message-send-cont .disable-btn[data-v-907b0c36]:active::after,\n.message-send-block .add-bot-wrapper .disable-btn[data-v-907b0c36]:active::after {\n  content: none;\n}\n.message-send-block .message-send-cont .disabled-cont-btn[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .disabled-cont-btn[data-v-907b0c36] {\n  filter: opacity(0.5) grayscale(1);\n}\n.message-send-block .message-send-cont .fade-enter-active[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .fade-enter-active[data-v-907b0c36],\n.message-send-block .message-send-cont .fade-leave-active[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .fade-leave-active[data-v-907b0c36] {\n  transition: opacity .1s;\n}\n.message-send-block .message-send-cont .fade-enter[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .fade-enter[data-v-907b0c36],\n.message-send-block .message-send-cont .fade-leave-to[data-v-907b0c36],\n.message-send-block .add-bot-wrapper .fade-leave-to[data-v-907b0c36] {\n  opacity: 0;\n}\n.message-send-block .message-send-cont.add-bot-wrapper[data-v-907b0c36],\n.message-send-block .add-bot-wrapper.add-bot-wrapper[data-v-907b0c36] {\n  cursor: pointer;\n}\n.message-send-block .message-send-cont.add-bot-wrapper[data-v-907b0c36]:hover,\n.message-send-block .add-bot-wrapper.add-bot-wrapper[data-v-907b0c36]:hover {\n  background-color: var(--list-item-bghover);\n}\n.message-send-block .message-send-cont.add-bot-wrapper .connect[data-v-907b0c36],\n.message-send-block .add-bot-wrapper.add-bot-wrapper .connect[data-v-907b0c36] {\n  margin: auto;\n  font-size: 16px;\n  color: var(--toolbtn-active-color);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.bot-keyboard-btn[data-v-907b0c36] {\n  border: 1px solid;\n  border-radius: 4px;\n  height: 20px;\n  width: 20px;\n  padding: 2px;\n}\n.bot-keyboard-btn .bot-keyboard-btn-line[data-v-907b0c36] {\n  display: flex;\n}\n.bot-keyboard-btn .bot-keyboard-btn-line .bot-keyboard-btn-square[data-v-907b0c36] {\n  border-radius: 1px;\n  height: 5px;\n  width: 5px;\n  background-color: var(--toolbtn-color);\n  margin: 1px;\n}\n.bot-comands-btn[data-v-907b0c36] {\n  height: 20px;\n  width: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  border: 1px solid var(--toolbtn-color);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.bot-comands-btn[data-v-907b0c36]:hover {\n  border-color: inherit;\n}\n.selected-bot-btn[data-v-907b0c36] {\n  border-color: var(--toolbtn-active-color);\n}\n.selected-bot-btn .bot-keyboard-btn-square[data-v-907b0c36] {\n  background-color: #00AAFB !important;\n}\n.message-send-block-locked[data-v-907b0c36] {\n  display: flex;\n  align-items: center;\n}\n.message-send-block-locked i[data-v-907b0c36] {\n  color: var(--toolbtn-color-hover);\n  margin-left: 24px;\n  margin-right: 32px;\n}\n.message-send-block-locked span[data-v-907b0c36] {\n  color: #cccccc;\n  font-size: 16px;\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n.warning-message[data-v-907b0c36] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 18px;\n  font-size: small;\n  background-color: var(--list-item-bghover);\n  border-top: 1px solid var(--border-bottom-section);\n}\n@keyframes link-to-new-msgs-in-907b0c36 {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n.link-to-new-msgs-fade-enter-active[data-v-907b0c36],\n.link-to-new-msgs-fade-leave-active[data-v-907b0c36] {\n  animation: link-to-new-msgs-in-907b0c36 0.1s ease-in;\n}\n.link-to-new-msgs-fade-enter[data-v-907b0c36],\n.link-to-new-msgs-fade-leave-to[data-v-907b0c36] {\n  animation: link-to-new-msgs-in-907b0c36 0.5s ease-in reverse;\n}\n.link-to-new-msgs[data-v-907b0c36] {\n  text-align: center;\n  position: absolute;\n  bottom: 29px;\n  right: 29px;\n  width: 50px;\n  height: 50px;\n  background-color: var(--link-new-msgs-bgcolor);\n  box-shadow: -1px 1px 4px 0px var(--link-new-message-shadow);\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  font-size: 25px;\n  color: var(--custom-textarea-color);\n  transition-property: opacity;\n  transition-duration: .5s;\n  opacity: 1;\n  visibility: visible;\n  z-index: 0;\n}\n.link-to-new-msgs.novisible[data-v-907b0c36] {\n  transition-property: opacity;\n  transition-duration: .5s;\n  visibility: hidden;\n  opacity: 0;\n}\n.link-to-new-msgs .unwatched-count[data-v-907b0c36] {\n  position: absolute;\n  background-color: var(--elem-red-color);\n  color: #faebef;\n  border-radius: 13px;\n  right: -3px;\n  top: -3px;\n  font-size: 12px;\n  padding: 1px 5.5px 0px 5.5px;\n}\n.link-to-new-msgs i[data-v-907b0c36] {\n  margin: auto;\n}\n.message-input[data-v-907b0c36] {\n  outline: none;\n  resize: none;\n  width: 100%;\n  background-color: inherit;\n  max-height: 190px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border: none;\n  align-self: flex-end;\n  margin: auto;\n  /*&::-webkit-input-placeholder { font-size: 1.2em;}\n      &::-moz-placeholder { color:#f00; font-family: Georgia;}\n      &:-ms-input-placeholder { color:#f00; font-family: Georgia;}\n      &:-moz-placeholder { color:#f00; font-family: Georgia;}*/\n}\n.message-overflow .message-overflow-alert[data-v-907b0c36] {\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  margin: auto 10px 10px 10px;\n  padding: 10px;\n  height: 40px;\n  line-height: 20px;\n  border-radius: 5px;\n  border: solid 1px #b84b4b;\n  color: #b81c1c;\n  background-color: rgba(211, 88, 26, 0.3);\n}\n.message-overflow .message-overflow-alert span[data-v-907b0c36] {\n  align-self: flex-start;\n}\n.message-overflow .message-overflow-alert div[data-v-907b0c36] {\n  align-self: flex-end;\n  margin: auto 0px auto auto;\n  cursor: pointer;\n}\n.message-overflow .fade-enter-active[data-v-907b0c36],\n.message-overflow .fade-leave-active[data-v-907b0c36] {\n  transition: opacity .5s;\n}\n.message-overflow .fade-enter[data-v-907b0c36],\n.message-overflow .fade-leave-to[data-v-907b0c36] {\n  opacity: 0;\n}\n.notice-new-msg-wrapper[data-v-907b0c36] {\n  width: calc(100% + 50px);\n  margin: 0 auto 0 -25px;\n  padding: 13px 0;\n  display: flex;\n}\n.notice-new-msg-wrapper .notice-new-msg[data-v-907b0c36] {\n  width: 100%;\n  background-color: var(--message-system-bgcolor);\n  border-radius: 3px;\n  text-align: center;\n  padding: 3px 5px;\n  color: var(--elem-grey-color);\n  margin: auto;\n  font-size: 12px;\n  justify-content: center;\n}\n.with-scroll li.notice-new-msg-wrapper[data-v-907b0c36] {\n  margin-left: -10px;\n  width: calc(100% + 35px);\n}\n@keyframes notice-new-msg-in-907b0c36 {\n0% {\n    transform: scale(0);\n}\n100% {\n    transform: scale(1);\n}\n}\n@keyframes notice-new-msg-out-907b0c36 {\n0% {\n    transform: scale(1);\n}\n100% {\n    transform: scale(0);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
